import "./tournament-message-schedule.scss";
import { useEffect } from "react";
import {
  GSForm,
  GSSidePanelPage,
  useFormDataValidation,
} from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getMessage,
  updateMessage,
  setCurrentMessage,
  selectCurrentMessage,
  selectMessagesNotifications,
  clearNotifications,
} from "../../../reducers/messagesSlice";
import { useNotificationBanner } from "../../../hooks/notificationHooks";
import { getDateTimeYMD, getIsoDateTime } from "../../../helpers/Dates";

const TournamentMessageSchedule = () => {
  const navigate = useNavigate();
  const match = useMatch("/:tournamentID/messages/:messageID/schedule");
  const dispatch = useDispatch();
  const currentMessage = useSelector(selectCurrentMessage);
  const notifications = useSelector(selectMessagesNotifications);

  const [context, isValid, setIsValid] = useFormDataValidation({
    initialValid: false,
    data: currentMessage,
    setData: (update) => dispatch(setCurrentMessage(update)),
  });

  useEffect(() => {
    dispatch(getMessage({ tournamentID: match?.params?.tournamentID, messageID: match?.params?.messageID }));
  }, [dispatch, match?.params?.tournamentID, match?.params?.messageID]);

  const isScheduledInFuture = (value) =>
    !!value && new Date(value).getTime() > Date.now();

  const goBack = () => {
    dispatch(clearNotifications());
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: "Schedule Message",
      leftIcon: faChevronLeft,
      leftButtonClick: goBack,
    };
  };

  const handleSchedule = () => {
    setIsValid(false);
    const scheduledFor = currentMessage?.scheduledFor
      ? getIsoDateTime(currentMessage.scheduledFor)
      : null;
    dispatch(
      updateMessage({
        tournamentID: match?.params?.tournamentID,
        messageID: match?.params?.messageID,
        data: { scheduledFor },
      })
    );
    navigate(`/${match?.params?.tournamentID}/messages/${match?.params?.messageID}/schedule/confirmation`)
  };

  const getFormSections = () => {
    return [
      {
        type: "vertical xx-large-gap",
        fields: [
          {
            label: "Scheduled Date & Time",
            isEditable: true,
            required: true,
            type: "datetime-local",
            min: getDateTimeYMD(new Date()),
            value: currentMessage?.scheduledFor ? getDateTimeYMD(currentMessage.scheduledFor) : "",
            onChange: (e) => context?.updateData(e.target.value, "scheduledFor"),
            failedValidation: context?.validationFailed,
            validation: {
              isValid: isScheduledInFuture,
              invalidLabel: "Scheduled date and time must be in the future.",
            },
          },
        ],
      },
    ];
  };

  const getContent = () => {
    return (
      <GSForm formTitle="Schedule Message" formSections={getFormSections()} />
    );
  };

  const getDrawerActions = () => {
    return [
      {
        name: "Schedule",
        isDisabled: !isValid,
        action: handleSchedule,
        type: "black",
      },
      {
        name: "Cancel",
        action: goBack,
        type: "grey",
      },
    ];
  };

  const getDrawer = () => {
    return { actions: getDrawerActions() };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    <tournament-message-schedule>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        drawer={getDrawer()}
      />
    </tournament-message-schedule>
  );
};

export default TournamentMessageSchedule;
